export interface Module {
  number: number
  title: string
  body: string
  tagline: string
  color: string
}

export const modules: Module[] = [
  {
    number: 1,
    title: 'PREVENTIVE MAINTENANCE SYSTEM',
    body: 'Plan, schedule and complete preventive maintenance before small problems become larger failures. Use daily, weekly and monthly routines, recurring task schedules, equipment checks and maintenance tracking tools to stay ahead of upcoming work.',
    tagline: 'Plan. Prevent. Complete.',
    color: '#26313A',
  },
  {
    number: 2,
    title: 'INSPECTIONS & MAINTENANCE CHECKLISTS',
    body: 'Perform organized inspections across equipment, systems and facility areas. Use practical checklists for mechanical, electrical, HVAC, plumbing, building, safety and general maintenance conditions that require attention.',
    tagline: 'Inspect. Identify. Follow up.',
    color: '#C0392B',
  },
  {
    number: 3,
    title: 'FAULT FINDING & TROUBLESHOOTING',
    body: 'Move from common maintenance symptoms to a clearer troubleshooting sequence. Work through no-starts, abnormal noise, vibration, overheating, leaks, low performance, electrical symptoms, pumps, fans and other everyday maintenance problems.',
    tagline: 'Observe. Check. Isolate.',
    color: '#E1701A',
  },
  {
    number: 4,
    title: 'WORK ORDERS & MAINTENANCE PRIORITIES',
    body: 'Turn incoming maintenance requests into organized, actionable work. Use work-order templates, priority classifications, job preparation tools, pending-work tracking and closeout systems to keep maintenance tasks under control.',
    tagline: 'Prioritize. Execute. Complete.',
    color: '#2E7D46',
  },
  {
    number: 5,
    title: 'MAINTENANCE RECORDS & ASSET CONTROL',
    body: 'Keep equipment information, service history and maintenance records organized. Track assets, repairs, breakdowns, parts replacements, recurring problems, equipment condition, warranties and maintenance history in one structured system.',
    tagline: 'Record. Track. Review.',
    color: '#1B6CA8',
  },
  {
    number: 6,
    title: 'MAINTENANCE CONTROL CENTER',
    body: 'Bring daily, weekly and monthly maintenance activities together in one organized workflow. Control priorities, preventive maintenance, open issues, equipment status, pending repairs, parts requirements, handovers and upcoming maintenance tasks.',
    tagline: 'Organize. Monitor. Control.',
    color: '#6B3FA0',
  },
]

export interface Bonus {
  number: number
  title: string
  subtitle: string
  body: string
  tagline: string
}

export const bonuses: Bonus[] = [
  {
    number: 1,
    title: 'EMERGENCY MAINTENANCE RESPONSE PLAYBOOK™',
    subtitle: 'Fast-Action Procedures for Urgent Maintenance Situations',
    body: 'Organize the initial response to leaks, unexpected shutdowns, overheating, abnormal equipment conditions and other urgent maintenance situations with structured response and follow-up tools.',
    tagline: 'Assess. Respond. Follow up.',
  },
  {
    number: 2,
    title: 'MAINTENANCE TROUBLESHOOTING QUICK REFERENCE™',
    subtitle: 'Symptom-to-Check Reference for Everyday Maintenance Problems',
    body: 'Start with the observed symptom and follow organized initial checks for no-starts, abnormal noise, vibration, overheating, leaks, low performance and other common maintenance problems.',
    tagline: 'Observe. Check. Isolate.',
  },
  {
    number: 3,
    title: 'PARTS & SPARE INVENTORY CONTROL KIT™',
    subtitle: 'Organize Critical Parts, Stock Levels and Reorders',
    body: 'Keep maintenance parts, consumables and critical spares organized with practical inventory records, storage controls, usage tracking and reorder tools.',
    tagline: 'Identify. Track. Reorder.',
  },
  {
    number: 4,
    title: 'MAINTENANCE HANDOVER & COMMUNICATION KIT™',
    subtitle: 'Clearer Shift Handoffs, Repair Updates and Maintenance Communication',
    body: 'Document equipment status, open repairs, temporary fixes, required parts, completed work and next actions with structured maintenance communication tools.',
    tagline: 'Record. Communicate. Handover.',
  },
  {
    number: 5,
    title: '30-DAY MAINTENANCE RESET PLAN™',
    subtitle: 'A Practical Framework to Organize Your Maintenance Operation',
    body: 'Follow a structured 30-day framework to organize assets, preventive maintenance, inspections, work orders, backlog, records, spare parts, handovers and maintenance priorities.',
    tagline: 'Organize. Implement. Control.',
  },
]
